import React, { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Super-admin-only header read-out of the server's current wall-
 * clock time in Asia/Jerusalem. Lets the operator verify "what
 * time does the system think it is" before debugging anything
 * schedule-dependent (auto-lock at end of day, off-hours
 * enforcement, etc.).
 *
 * The component fetches /api/admin/system-time on mount and then
 * every minute. Between polls the seconds don't tick — the value
 * is intentionally minute-granular to avoid drift confusion: if
 * the user wants the precise second they can hit refresh.
 *
 * Renders nothing while the first response is still loading, so
 * the header doesn't flash an empty pill on first paint.
 */
function SystemClock() {
  const [text, setText] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchNow = () => {
      axios.get('/api/admin/system-time')
        .then(res => {
          if (cancelled) return;
          setText(res.data.human);
        })
        .catch(() => {
          if (cancelled) return;
          // Render a soft error rather than crashing the whole
          // header — the clock is informational, not load-blocking.
          setText('— שעון לא זמין —');
        });
    };

    fetchNow();
    const interval = setInterval(fetchNow, 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  if (text === null) return null;

  return (
    <div
      title="השעה והתאריך כפי שהמערכת רואה אותם — שימושי כדי לוודא שאין סחף שעון לפני בדיקת לוחות זמנים ונעילה אוטומטית"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0.35rem 0.75rem',
        background: '#f3f4f6',
        border: '1px solid #e5e7eb',
        borderRadius: '999px',
        fontSize: '0.82rem',
        fontWeight: 500,
        color: '#374151',
        fontFamily: 'Heebo, sans-serif',
      }}
    >
      🕒 {text}
    </div>
  );
}

export default SystemClock;
